<div
  class="h-full w-full text-caption flex flex-col gap-2 p-2 pb-20 bg-neutral-10 scrollbar"
>
  @if (composeStore.isLoading()) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @defer (on timer(1000ms)) {
    @if (
      outlookStore.hasActiveAccount() &&
      outlookStore.hasInvalidComposeProperties() &&
      outlookStore.versionValidForNewSync()
    ) {
      <maximizer-outlook-status-message
        type="error"
        [message]="'outlook.compose.invalidSaveWarning' | translate"
        [actionText]="'outlook.buttons.refresh' | translate"
        (action)="refresh()"
      ></maximizer-outlook-status-message>
    }
  }

  <!-- Add recipients search -->
  <maximizer-outlook-entry-search
    [entryActions]="buildRecipientActions"
    (searchActiveChange)="searchActive.set($event)"
  ></maximizer-outlook-entry-search>
  <div class="flex flex-col gap-2" [class.hidden]="searchActive()">
    <!-- In Maximizer; save email to entries -->
    <div class="bg-white rounded p-3 flex flex-col gap-2">
      <p class="subtitle-2">
        {{ 'outlook.compose.saveEmailTitle' | translate }}
      </p>
      <maximizer-outlook-compose-save-to-email
        #saveToEmail
      ></maximizer-outlook-compose-save-to-email>
    </div>

    <!-- Related Opportunity/Case -->
    @if (showRelatedSection) {
      <button
        id="outlook-main-ui-compose-related"
        class="bg-white rounded p-3 flex justify-between items-center text-bush-green-140 hover:bg-bush-green-15 hover:cursor-pointer text-left"
        type="button"
        (click)="navigateToRelated()"
        [disabled]="composeStore.isLoading()"
      >
        <p class="subtitle-2">{{ relatedTitle }}</p>
        <span class="fa-icons icon-14 icon-chevron-right mx-2"></span>
      </button>
    }

    <!-- Not in Maximizer -->
    <div class="bg-white rounded p-3 flex flex-col gap-2">
      <p class="subtitle-2">
        {{ 'outlook.compose.notInMaximizer' | translate }} ({{
          composeStore.notInMaximizer().length
        }})
      </p>
      @if (composeStore.notInMaximizer().length > 0) {
        <maximizer-outlook-compose-add-entry></maximizer-outlook-compose-add-entry>
      }
    </div>

    <!-- Empty state -->
    @if (showEmptyStateMessage()) {
      <div class="py-6 px-4 text-center flex flex-col gap-2">
        <p class="subtitle-2 text-neutral-90">
          {{ 'outlook.compose.emptyTitle' | translate }}
        </p>
        <p class="text-body text-neutral-70">
          {{ 'outlook.compose.emptyDescription' | translate }}
        </p>
      </div>
    }
  </div>
</div>

<maximizer-outlook-notification
  entryId="entries"
  #notification
  [closable]="true"
>
</maximizer-outlook-notification>

<maximizer-outlook-notification
  entryId="email"
  #recipientNotification
  [closable]="true"
>
</maximizer-outlook-notification>
